import key from '../lib/constants'
import { KEY_STORE } from 'Utils/globalConstants'
import { saveDataLocal } from 'Utils/globalFunction'

export function setMetaMask (metamask) {
  return {
    type: key.SET_METAMASK,
    payload: metamask
  }
}

export function setUserAuthentication (userAuth) {
  saveDataLocal(KEY_STORE.USER_AUTHENTICATION, userAuth)
  return {
    type: key.SET_USER_AUTHENTICATION,
    payload: userAuth
  }
}
